/* =====================================================================
   LUNEOR — catalog showcase (carousel + particle shapes + world toggle)
   ===================================================================== */
(() => {
  function init(sec) {
    if (!sec || sec._init) return; sec._init = true;
    const { $, $$, FINE, mouse, lerp, REDUCE } = window.Luneor;
    let D = [];
    try { D = JSON.parse($('[data-pieces]', sec).textContent); } catch (e) { return; }
    const items = $$('[data-item]', sec), side = $$('[data-go]', sec);
    const n = Math.min(D.length, items.length); if (!n) return;
    const fx = window.LuneorParticles ? window.LuneorParticles($('[data-fx]', sec), { cx: .5, cy: innerWidth < 760 ? .36 : .4, scale: innerWidth < 760 ? 1.05 : .92 }) : null;
    let i = 0;

    const offR = document.getElementById('offR'), offB = document.getElementById('offB');
    let glitchUntil = 0;

    function render() {
      const d = D[i];
      items.forEach((el, k) => {
        let off = k - i; if (off > n / 2) off -= n; if (off < -n / 2) off += n;
        el.dataset.pos = off === 0 ? 'c' : off === -1 ? 'l' : off === 1 ? 'r' : off < 0 ? 'fl' : 'fr';
        el.tabIndex = off === 0 ? 0 : -1;
      });
      side.forEach((b, k) => { b.classList.toggle('on', k === i); b.setAttribute('aria-current', k === i); });
      sec.style.setProperty('--c', d.color);
      document.documentElement.style.setProperty('--c', d.color);
      $('[data-k]', sec).textContent = d.kicker || '';
      $('[data-name]', sec).textContent = d.name;
      $('[data-notes]', sec).innerHTML = (d.notes || []).filter(x => x[1]).map(x => `<div><small>${x[0]}</small><b>${x[1]}</b></div>`).join('');
      const esc = t => String(t || '').replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      $('[data-lines]', sec).innerHTML = [[sec.dataset.lCos, d.cosplay], [sec.dataset.lEvery, d.everyday]].filter(x => x[1]).map(x => `<p><small>${esc(x[0])}</small>${esc(x[1])}</p>`).join('');
      $('[data-price]', sec).innerHTML = d.price + (d.compare ? ` <s>${d.compare}</s>` : '');
      $('[data-link]', sec).href = d.url;
      const info = $('[data-info]', sec); info.classList.remove('swap'); void info.offsetWidth; info.classList.add('swap');
      fx && fx.set(d.shape, d.color);
      glitchUntil = performance.now() + 420;
    }
    const go = k => { i = (k + n) % n; render(); };
    $('[data-prev]', sec).onclick = () => go(i - 1);
    $('[data-next]', sec).onclick = () => go(i + 1);
    side.forEach((b, k) => b.onclick = () => go(k));
    items.forEach((el, k) => el.addEventListener('click', e => { if (k !== i) { e.preventDefault(); e.stopImmediatePropagation(); go(k); } }, true));
    addEventListener('keydown', e => { const r = sec.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight * .5) return; if (e.key === 'ArrowLeft') go(i - 1); if (e.key === 'ArrowRight') go(i + 1); });
    // swipe
    let sx = null;
    sec.addEventListener('touchstart', e => sx = e.touches[0].clientX, { passive: true });
    sec.addEventListener('touchend', e => { if (sx == null) return; const dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 50) go(i + (dx < 0 ? 1 : -1)); sx = null; });

    // tilt + glitch loop on the centre piece
    let tx = 0, ty = 0;
    (function loop(now) {
      if (!sec.isConnected) return;
      const c = items[i], o = c && c.querySelector('.obj');
      if (o) {
        tx = lerp(tx, FINE ? mouse.x / innerWidth - .5 : 0, .06); ty = lerp(ty, FINE ? mouse.y / innerHeight - .5 : 0, .06);
        o.style.transform = `rotateY(${tx * 18}deg) rotateX(${ty * -12}deg)`;
        const g = now < glitchUntil ? (glitchUntil - now) / 420 : 0;
        if (g > .02 && !REDUCE) { o.style.filter = 'url(#rgb)'; const v = (6 + Math.random() * 16) * g; offR && offR.setAttribute('dx', v); offB && offB.setAttribute('dx', -v); }
        else if (o.style.filter) o.style.filter = '';
      }
      requestAnimationFrame(loop);
    })(performance.now());

    render();
  }
  const boot = (r = document) => r.querySelectorAll('[data-catalog]').forEach(init);
  document.addEventListener('luneor:ready', () => boot());
  document.addEventListener('shopify:section:load', e => window.Luneor && boot(e.target));
})();
